module.exports = __webpack_public_path__ + "img/ChargingStation.8b1d2fe1.svg";